// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39febcd5","767":"ac803439","772":"de7f90aa"}[chunkId] + ".chunk.js";
};